var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',{attrs:{"type":"card"},model:{value:(_vm.tabsKey),callback:function ($$v) {_vm.tabsKey=$$v},expression:"tabsKey"}},[_c('el-tab-pane',{attrs:{"name":"set","label":"規則設定"}},[_c('set')],1),_c('el-tab-pane',{attrs:{"name":"change","label":"兌換中心"}},[_c('change')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }